// extracted by mini-css-extract-plugin
module.exports = {"emptyState":"EmptyState_emptyState__3PKi5","title":"EmptyState_title__3DUWI"};